import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { SippApi } from '../../../services/SippExpress'
import { IUser } from '../../../types/User'

interface RequestOptions {
  email: string,
  options?: AxiosRequestConfig
}

export const fetchUserAsync = createAsyncThunk(
  'users/fetchUser',
  async ({ email, options }: RequestOptions, { rejectWithValue }) => {
    try {
      const response = (await SippApi.fetchUser(email, options)) as AxiosResponse<Partial<IUser>>

      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)


export const fetchUserAsyncBuilder = (builder: any) => {
  builder.addCase(fetchUserAsync.pending, (state, ) => {
    state.loading = true
    state.error = ''

  })
  builder.addCase(fetchUserAsync.fulfilled, (state, action) => {

    state.loading = false
    state.user = action.payload
    state.error = ''
  })

  builder.addCase(fetchUserAsync.rejected, (state,) => {

    state.loading = false
    state.error = 'Something went wrong'
    state.user = null
  })
}

